// extracted by mini-css-extract-plugin
export default {"root":"ReadonlyField_root__KkYAU"};